import { render, staticRenderFns } from "./CaseloadTable.vue?vue&type=template&id=0c225b36&scoped=true&"
import script from "./CaseloadTable.vue?vue&type=script&lang=js&"
export * from "./CaseloadTable.vue?vue&type=script&lang=js&"
import style0 from "./CaseloadTable.vue?vue&type=style&index=0&id=0c225b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c225b36",
  null
  
)

export default component.exports